<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox v-model="fields.enableAnchor" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>

        <div class="mb-4">
          <label class="label-input">Style</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="6">
                <ColorPicker v-model="fields.background" name="background" label="Background" default-color="#ffffff" />
              </v-col>
              <v-col cols="12" md="6">
                <ColorPicker v-model="fields.textColor" name="text-color" label="Text Color" default-color="#000000" />
              </v-col>
              <v-col cols="12" md="4">
                <v-checkbox class="mt-0" v-model="fields.topPadding" label="Top Padding" hide-details />
              </v-col>
              <v-col cols="12" md="4">
                <v-checkbox class="mt-0" v-model="fields.bottomPadding" label="Bottom Padding" hide-details />
              </v-col>
              <v-col cols="12">
                <v-switch v-model="fields.enableContainerPage" label="Enable container page" hide-details />
              </v-col>
              <v-col cols="12" v-if="fields.enableContainerPage">
                <ColorPicker
                  v-model="fields.backgroundContainer"
                  name="background-container"
                  label="Container Background"
                  default-color="#ffffff"
                />
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-4">
          <label class="label-input">Title Card</label>
          <div class="group-item">
            <v-checkbox v-model="fields.showTitle" label="Show title" hide-details class="mt-0 mb-2" />
            <ckeditor :editor="editor" v-model="fields.titleCard" :config="editorConfig" />
          </div>
        </div>

        <div class="mb-4">
          <div class="d-flex justify-space-between align-center mb-2">
            <div class="d-flex align-center" style="gap: 10px">
              <label class="label-input mb-0">Statistics List</label>
              <v-checkbox v-model="fields.listShow" hide-details class="mt-0" />
            </div>
            <v-btn small text color="primary" @click="handleAddItem">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Item</span>
            </v-btn>
          </div>
          <div class="group-item">
            <div class="mb-3">
              <ColorPicker
                v-model="fields.highlightColor"
                name="highlight-color"
                label="Highlight Color"
                default-color="#000000"
              />
            </div>

            <v-expansion-panels accordion>
              <v-expansion-panel v-for="(item, index) in fields.listItem" :key="`statistics-item-${index}`">
                <v-expansion-panel-header>
                  <div class="d-flex justify-space-between align-center" style="width: 100%">
                    <span>Item {{ index + 1 }}</span>
                    <v-btn icon @click.stop="handleRemoveItem(index)">
                      <v-icon size="18" color="#ff6c6c">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-text-field v-model="item.value" label="Value (ex: 92%)" />
                  <label class="mb-2 d-block">Content</label>
                  <ckeditor :editor="editor" v-model="item.content" :config="editorConfig" />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </div>

        <div class="mb-4">
          <label class="label-input">Hint Block</label>
          <div class="group-item">
            <v-checkbox v-model="fields.showHint" label="Show hint block" hide-details class="mt-0 mb-2" />
            <div class="mb-3">
              <UploadImage
                @callback="handleUploadHintIcon"
                :image="{ imageSrc: fields.iconHint || '' }"
                :height="`160`"
                :typeUpload="'image'"
                @callbackDelete="handleRemoveHintIcon"
              />
            </div>
            <ckeditor :editor="editor" v-model="fields.contentHint" :config="editorConfig" />
          </div>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
import ColorPicker from './common/color-picker.vue';

export default {
  name: 'card-statistics-yuri-section-editor',
  components: {
    UploadImage,
    ColorPicker,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'Card Statistics Yuri Section',
        enableAnchor: false,
        topPadding: true,
        bottomPadding: true,
        background: '#FFFFFF',
        textColor: '#000000',
        enableContainerPage: false,
        backgroundContainer: '#FFFFFF',
        showTitle: true,
        titleCard: "<h2>Statistics Don't Lie</h2><p>Real People, Real Results</p>",
        listShow: true,
        listItem: [],
        showHint: true,
        contentHint: 'Based on 11,761+ Customer Reviews',
        iconHint: '',
        highlightColor: '#000000',
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
      listItem: Array.isArray(this.sectionEditor.sectionExtract?.listItem)
        ? this.sectionEditor.sectionExtract.listItem
        : this.fields.listItem,
    };

    if (!this.fields.listItem.length) {
      this.handleAddItem();
    }
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleAddItem() {
      this.fields.listItem.push({
        value: '92%',
        content: "<h3>Parents</h3><p>of parents reported their child's behavior improved after using our robot.</p>",
      });
    },
    handleRemoveItem(index) {
      this.fields.listItem.splice(index, 1);
    },
    handleUploadHintIcon(obj) {
      this.fields.iconHint = obj?.imageSrc || '';
    },
    handleRemoveHintIcon() {
      this.fields.iconHint = '';
    },
    handleSave() {
      const payload = {
        ...this.fields,
        listItem: (this.fields.listItem || []).map(item => ({
          value: item.value || '',
          content: item.content || '',
        })),
        iconHint: this.fields.iconHint || '',
      };
      const updateHtml = updateHtmlFromData.sectionCardStatisticsYuri(this.sectionEditor.section.html, payload);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
.group-item {
  padding: 12px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}

.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}

.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}

.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
